

const $ = window.jQuery;

import Emitter from 'es6-event-emitter';
import Utils from '../utils/utils';
import Cookie from '../utils/cookie';

export default class Store extends Emitter {
  
  constructor() {
    super();

    this.cache = new Map();
    this.currentUrl = this.normalizeUrl( window.location.href );
    
    this.lastUrl = this.currentUrl;
    this.navigationDirection = 'forward';
    this.loadPage( this.currentUrl, { silent: true } );
    this.restorePageAfterReload();
    
  }

  /**
   * Restores a page after a reload
   */
  restorePageAfterReload() {
    const cookieName = 'pageDataBeforeUnload';
    let pageData = Cookie.get(cookieName);
    Cookie.delete(cookieName);
    if( pageData ) {
      pageData = JSON.parse(pageData);
      if( pageData.url === window.location.href ) this.updatePageData(pageData);
    }
    Cookie.delete(cookieName);
    window.addEventListener('beforeunload', e => {
      this.storeScrollPositions( this.currentUrl );
      const page = this.getPage( this.currentUrl );
      page.data.url = this.currentUrl;
      Cookie.set(cookieName, JSON.stringify(page.data), 0.0001);
    });
  }

  /**
   * Get a page or create a new one
   * @param {string} url 
   * @returns {Page} Page
   */
  getPage( url ) {
    url = this.normalizeUrl( url );
    let page = this.getPageFromCache( url );
    
    if( !page ) {
      page = new Page( url );
      this.addPageToCache( page, url );
    }
    return page;
  }

  /**
   * Set cached data for URL
   * @param {object} newData 
   * @param {string} url 
   */
  addPageToCache( page, url = null ) {
    url = this.normalizeUrl( url );
    this.cache.set(url, page);
    this.cleanup();
    return this;
  }

  /**
   * Get cached data for URL or current URL
   * @param {string} url 
   */
  getPageFromCache( url = null ) {
    url = this.normalizeUrl( url );
    let page = this.cache.get( url ) || false;
    return page;
  }

  /**
   * 
   * @param {object} data 
   * @param {string} url 
   */
  updatePageData( data, url = null ) {
    url = this.normalizeUrl( url );
    const page = this.getPage( url );
    page.update( data );
    return page;
  }

  /**
   * Get data from a page
   * @param {*} key 
   */
  getPageData( key = false, url = null, fallback = null ) {
    url = this.normalizeUrl( url );
    const page = this.getPage( url );
    let data = page.data;
    if( key ) {
      data = typeof page.data[key] !== 'undefined' ? page.data[key] : fallback;
    }
    return data;
  }

  /**
   * Load an URL
   * @param {string} url 
   * @param {object} options 
   */
  async loadPage( url, options ) {
    
    url = this.normalizeUrl( url );
    
    options = $.extend({
      silent: false,
      useCache: true,
      overwriteNextPageData: false,
    }, options );

    if( !options.silent ) {
      this.storeScrollPositions( this.currentUrl );
      this.setCurrentUrl( url );
    }

    let page = this.getPage( url );

    if( options.overwriteNextPageData ) {
      this.updatePageData( options.overwriteNextPageData, url )
    }

    if( options.useCache && page.state === 'loaded' ) {
      return page;
    } else {
      if( !options.silent ) { 
        this.trigger('loadStart') 
      }
      page = await page.load( url );
      return page;
    }
  }

  /**
   * Stores scroll positions for an url
   * @param {*} page 
   */
  storeScrollPositions( url ) {
    url = this.normalizeUrl(url);
    let scrollPositions = {};
    $('[data-scrollable-id]').each((i, el) => {
      const id = el.getAttribute('data-scrollable-id');
      scrollPositions[id] = el.scrollTop;
    });
    this.updatePageData({
      scrollPositions: scrollPositions
    },  url)
  }

  /**
   * Cleanup cache
   */
  cleanup() {
    var maxCacheEntries = 10;
    var index = 0;
    var mapSize = this.cache.size;
    this.cache.forEach(function( value, key, map ) {
      index ++;
      if( mapSize - index > maxCacheEntries - 1 ) {
        map.delete( key );
      }
    } );
  }

  /**
   * Normalize an URL for the store
   * @param {string} url 
   */
  normalizeUrl( url ) {
    url = url || window.location.href;
    url = url.split('#')[0];
    url = Utils.addTrailingSlash( url );
    return url;
  }

  /**
   * Set curent Store URL
   * @param {string} url 
   */
  setCurrentUrl( url ) {
    this.lastUrl = this.currentUrl;
    this.currentUrl = url;
  }

}

/**
 * Loads URLs and stores them in the store
 */
class Page {

  constructor( url ) {
    this.state = 'idle';
    this.url = url;
    this.data = {
      scrollPositions: {},
      openAccordeonItem: ''
    }
  }
  
  /**
   * Load an URL
   * @param {string} url 
   */
  async load( url ) {
    this.state = 'loading';
    try {
      let response = await $.get(url);
      this.state = 'loaded';
      this.data.$document = $('<div/>').html( response );
      return this;
    } catch( xhr ) {
      this.state = 'idle';
      this.data.$document = $('<div/>').html( xhr.responseText );
      return this;
    }
  }

  /**
   * Update data
   * @param {object} newData 
   */
  update( newData ) {
    this.data = $.extend( this.data, newData );
    return this;
  }
  
}
